import React from 'react';
import style from './Item.module.css';
import classes from 'react-style-classes';

var Item = function Item(props) {
  return /*#__PURE__*/React.createElement('li', {
    className: classes(style.item, props.isActive && style.active, props.className),
    onClick: props.onClick,
    tabIndex: 0
  }, props.children);
};

Item.defaultProps = {
  children: null,
  onClick: function onClick() {
    return null;
  },
  isActive: false,
  className: null
};
export default Item;